import { render } from "./A9Data.vue?vue&type=template&id=1e58a24b&scoped=true"
import script from "./A9Data.vue?vue&type=script&lang=js"
export * from "./A9Data.vue?vue&type=script&lang=js"

import "./A9Data.vue?vue&type=style&index=0&id=1e58a24b&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e58a24b"]])

export default __exports__